module.exports = __webpack_public_path__ + "static/img/aqzs05.0755eaca.jpg";